import TopBar from "./TopBar"



function App() {
  return (
    <>
        <TopBar />
    </>
  );
}

export default App;
